"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormattedPreview = exports.Label = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var numberjs_1 = tslib_1.__importDefault(require("@gooddata/numberjs"));
var stripColors = numberjs_1.default.stripColors, numberFormat = numberjs_1.default.numberFormat, colors2Object = numberjs_1.default.colors2Object;
exports.Label = function (_a) {
    var value = _a.value, style = _a.style, className = _a.className;
    return (react_1.default.createElement("div", { className: classnames_1.default("gd-measure-format-preview-formatted", className) },
        react_1.default.createElement("span", { style: style }, value)));
};
exports.FormattedPreview = function (_a) {
    var previewNumber = _a.previewNumber, format = _a.format, _b = _a.colors, colors = _b === void 0 ? true : _b, separators = _a.separators, customClassName = _a.className;
    if (format === "") {
        return react_1.default.createElement(exports.Label, null);
    }
    var preview = previewNumber !== null ? previewNumber : "";
    if (!colors) {
        var label_1 = numberFormat(preview, stripColors(format), undefined, separators);
        return react_1.default.createElement(exports.Label, { value: label_1, className: customClassName });
    }
    var _c = colors2Object(numberFormat(preview, format, undefined, separators)), label = _c.label, _d = _c.color, color = _d === void 0 ? "" : _d, _e = _c.backgroundColor, backgroundColor = _e === void 0 ? "" : _e;
    var style = { color: color, backgroundColor: backgroundColor };
    return react_1.default.createElement(exports.Label, { value: label, className: customClassName, style: style });
};
//# sourceMappingURL=FormattedPreview.js.map